// TopHeader.js

import React, { useReducer } from "react";
// import "./HeaderStyle.css";
import headerStyle from "./Header.module.css"
import Profile from "../ReuseableComp/HeaderItem";
import { FaRegUserCircle } from "react-icons/fa";
import { IoMdHelpCircleOutline } from "react-icons/io";
import {initialState, reducer} from "../Reduceres/reducer";
import { TOGGLE_PROFILE_DROPDOWN, TOGGLE_NOTIFICATION_DROPDOWN } from "../Reduceres/Action";

export const TopHeader = () => {
  
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <div className="topContainer">
      <div className="headerContaint">
        <header className="topHeader">
          <div className="headerLeft">
            <h2>SageionAmazing</h2>
          </div>
          <div className="headerRight">
            <span>
              <Profile
                id="help"
                customIcon={
                  <IoMdHelpCircleOutline
                    style={{ fontSize: "24px", color: "#1B5BFF" }}
                  />
                }
                text={["Documentation", "Help Center"]}
                padding="8px"
                color="#333"
                isOpen={state.notificationDropdownOpen}
                toggleDropdown={() => dispatch({ type: TOGGLE_NOTIFICATION_DROPDOWN })}
              />
            </span>

            <span>
              <Profile
                id="user"
                customIcon={
                  <FaRegUserCircle
                    style={{ fontSize: "24px", color: "#1B5BFF" }}
                  />
                }
                text={[
                  "Hello, Ritu",
                  "What's New?",
                  "Account Setting",
                  "Logout",
                ]}
                padding="8px"
                color="#333"
                isOpen={state.profileDropdownOpen}
                toggleDropdown={() => dispatch({ type: TOGGLE_PROFILE_DROPDOWN })}
              />
            </span>
          </div>
        </header>
      </div>
      {(state.notificationDropdownOpen || state.profileDropdownOpen) && (
        <div
          className="overlay"
          onClick={() =>
            dispatch({ type: state.notificationDropdownOpen ? TOGGLE_NOTIFICATION_DROPDOWN : TOGGLE_PROFILE_DROPDOWN })
          }
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 1,
          }}
        ></div>
      )}
    </div>
  );
};
